import { LitElement, html, css } from 'lit';

class LoadingSpinner extends LitElement {
  static properties = {
    active: { type: Boolean, reflect: true },
  };

  static styles = css`
    :host { display: none; }
    :host([active]) { display: block; position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 90; }
    .container { display: flex; align-items: center; justify-content: center; height: 100%; }
    .box { background: white; padding: 1.5rem; border-radius: 0.5rem; box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25); text-align: center; }
    .spinner { width: 3rem; height: 3rem; border: 3px solid #E5E7EB; border-top-color: #3B82F6; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto; }
    p { margin-top: 1rem; color: #374151; }
    @keyframes spin { to { transform: rotate(360deg); } }
  `;

  constructor() {
    super();
    this.active = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this._onShow = () => { this.active = true; };
    this._onHide = () => { this.active = false; };
    window.addEventListener('loading-show', this._onShow);
    window.addEventListener('loading-hide', this._onHide);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('loading-show', this._onShow);
    window.removeEventListener('loading-hide', this._onHide);
  }

  render() {
    return html`
      <div class="container">
        <div class="box">
          <div class="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    `;
  }
}

customElements.define('loading-spinner', LoadingSpinner);

export function showLoading() {
  window.dispatchEvent(new CustomEvent('loading-show'));
}

export function hideLoading() {
  window.dispatchEvent(new CustomEvent('loading-hide'));
}
